import React, { useState } from "react";
import "./Roofrepair.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Working_in_abseiling() {



  return (

    <div className="Roofrepair-page">
      <div className="Roofrepair-hero">
        <div className="Roofrepair-overlay">
          <h1>      עבודות סנפלינג  </h1>
        </div>
<div>
</div>
</div>
    <div className="page3">
 <div className="breadcrumb3">
  <Link to="/">בית</Link> /{" "}
  <Link to="/ProfessionalInformation"> מידע מקצועי</Link>/{" "}
   <Link to="/Working_at_Height">    עבודה בגובה</Link>/{" "}
    <Link to="/Working_in_abseiling">     עבודות סנפלינג   </Link>{" "}
</div>
    </div>

      {/* CONTENT */}
<div className="page4">
  <div className="container">

    <h2 className="top-text">
      ישנן סוגים שונים של עבודות סנפלינג, המתבצעות בגובה. למשל: איטום חיצוני של קירות הבניין, בקומות שהן מעל הקומה הראשונה. לפעמים, יש צורך לתקן צנרת חיצונית לבניין, או לתקן חלונות מחוץ לבניין. הדרך הנוחה ביותר לבצע עבודות אלו, היא באמצעות סנפלינג. במאמר זה, נסביר על המורכבות של ביצוע מלאכת תיקון באמצעות סנפלינג, ומהן המיומנויות הנדרשות מהעובד.
    </h2>
   <h2 className="main-title">
מדוע ביצוע עבודות סנפלינג, עדיפה על פני ביצוע עבודה באמצעות מנוף?
    </h2>
    <div className="content-row">

      <div className="image-box">
        <img src="/images/63.jpg" alt="roof" />
      </div>
      <div className="text-box">
        <p> ניתן לבצע עבודות באמצעות מנוף. אולם ביצוע של עבודות בסנפלינג, עדיפה יותר. ומדוע? משום שרכב המנוף, תופס מקום חנייה. ברחובות צרים, עלול רכב המנוף לחסום את תנועת הרכבים ברחוב, ולהשבית לגמרי את התנועה. לעומת זאת, ביצוע עבודות באמצעות סנפלינג, אינו מצריך רכב כבד. הפועל עולה ויורד באמצעות סנפלינג.</p>

    <h2 className="main-title">
נדרשת מיומנות ביצוע סנפלינג למשך זמן ארוך:


    </h2>
        <p>          אין ספק, שביצוע עבודה בגובה ועבודות בסנפלינג בפרט, מצריכה ירידה מסנפלינג מגובה רב. אולם, למבצע את העבודות, נדרשת מיומנות נוספת: נדרשת מיומנות לבצע סנפלינג למשך זמן רב. כידוע, פעולות תיקון ואיטום, יכולות לקחת לעיתים כמה שעות. לכן, הפועל המבצע את התיקונים, צריך מצד אחד לדעת לבצע את העבודה בזריזות, ומצד שני, שיהיה לו את היכולת להחזיק את עצמו על חבל הסנפלינג למשך כמה שעות.         </p>



      </div>




    </div>

    <h2 className="main-title">
ביצוע עבודה בסנפלינג- אינה פרנסה לחובבנים:


    </h2>

    <div className="bottom-text">
      <p>  ביצוע עבודות בסנפלינג, אינה פרנסה לחובבנים. על מנת להצליח להחזיק בסנפלינג בגובה, ולבצע עבודת ידיים מדויקת במשך כמה שעות, יש צורך בעובד המיומן בסנפלינג. לכן, מי שמבצע את העבודה, לא יכול להיות חובבן שרק עתה סיים ללמוד כיצד לגלוש בסנפלינג. לעבודה זו, מתקבלים עובדים עם אהבה עזה לספורט הסנפלינג, ועם ברק בעיניים בעת ביצוע הסנפלינג. בדרך כלל, יתקבלו לעבודה זו עובדים שטיילו במזרח הרחוק או באירופה, ושם טיפסו באמצעות סנפלינג לגובה רב מאוד. </p>

    <h2 className="main-title">
לעובד- נדרשת יכולת עמידה בכל תנאי מזג האוויר:

    </h2>

      <p>מהעובד המבצע עבודות סנפלינג, נדרשת יכולת עמידה בכל תנאי מזג אוויר. לפעמים, בגלל רטיבות פנימית קשה, או מסיבות אחרות, יהיה צורך לבצע את עבודת התיקון בתנאי מזג אוויר חם. הסנפלינג יתבצע תחת תנאי שרב כבד, וללא מזגן. לפעמים, עבודת התיקון, תצטרך להתבצע דווקא תחת תנאי מזג אוויר חורפיים. לפעמים תחת גשם, ולפעמים תחת רוחות חזקות. הפועל המבצע, הינו פועל מיומן, אשר יודע להתמודד מול רוחות פתאומיות חזקות, או תחת גשם פתאומי חזק. לכן, בדרך כלל חברות אלו יקבלו לעבודה עובדים אשר ביצעו ספורט סנפלינג תחת תנאי מזג אוויר קשים.

</p>


    </div>


     <ContactSection2/>
<div className="links">

  <Link to="/Working_at_Height" className="link-right" > עבודה בגובה </Link>
  <Link to="/Abseiling_sealing" className="link-left" >  איטום בסנפלינג    </Link>

</div>

      </div>
    </div>
  

      </div>
  );
}

